import store from '@/store.js'
// import router from '@/router.js'
import * as firebase from "firebase/app";

class FireService {
    static getRecipes() {
        return new Promise(async(resolve, reject) => {
            try {
                let unsubscribeMethod = await firebase
                    .firestore()
                    .collection(`recipes/${store.state.currentUser.uid}/user_recipes`)
                    .onSnapshot(doc => {
                        let allRecipes = [];
                        let deletedRecipes = [];
                        doc.docs.forEach(recipe => {
                            if (recipe.data().deleted_at) {
                                deletedRecipes.push({
                                    id: recipe.id,
                                    ...recipe.data()
                                });
                            } else {
                                allRecipes.push({
                                    id: recipe.id,
                                    ...recipe.data()
                                });
                            }
                        });
                        store.dispatch("setRecipes", allRecipes);
                    });
                resolve(unsubscribeMethod)
            } catch (error) {
                reject(error)
            }
        })
    }

    static createRecipe(recipe) {
        return new Promise(async(resolve, reject) => {
            try {
                let response = await firebase
                    .firestore()
                    .collection(
                        `recipes/${store.state.currentUser.uid}/user_recipes`
                    )
                    .add(recipe)
                resolve(response.id)
            } catch (error) {
                reject(error)
            }
        })
    }

    static updateRecipe(recipe) {
        return new Promise(async(resolve, reject) => {
            try {
                await firebase
                    .firestore()
                    .collection(
                        `recipes/${store.state.currentUser.uid}/user_recipes`
                    )
                    .doc(recipe.id)
                    .update(recipe);
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }

    static deleteRecipe(recipeId) {
        return new Promise(async(resolve, reject) => {
            try {
                await firebase
                    .firestore()
                    .collection(`recipes/${store.state.currentUser.uid}/user_recipes`)
                    .doc(recipeId)
                    .update({
                        deleted_at: new Date()
                    })
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }

    static createSampleRecipe() {
        return new Promise(async(resolve, reject) => {
            try {
                let recipe = { "title": "Sample Recipe", "tags": ["Delicious", "Quick & Easy"], "ingredients": [{ "unit": "g", "qty": "100", "name": "flour" }, { "unit": "ml", "qty": "200", "name": "water" }, { "unit": "clove", "qty": "2", "name": "garlic" }, { "unit": "", "qty": "8", "name": "chicken breasts" }, { "unit": "", "name": "Salt & Pepper" }], "method": ["This is the first method step.", "And another one.", "Pro tip: You can rearrange tips, ingredients & method steps!"], "cook_time": { "hr": "1", "min": "30" }, "prep_time": { "hr": "0", "min": "25" }, "description": "This is a sample recipe used to highlight the key features!", "meal_type": "Dinner" };
                recipe.updated_at = new Date().toISOString();
                await this.createRecipe(recipe)
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }
}

export default FireService